// Templat HTML dengan pelarian (escape) automatik — perlindungan XSS secara lalai.
// Nilai yang diselit dilarikan kecuali dibungkus raw(). Senarai (array) digabungkan.

const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;', '`': '&#96;' };

export class Raw {
  constructor(s) { this.s = String(s); }
  toString() { return this.s; }
}
export const raw = (s) => new Raw(s);
export const esc = (v) => String(v ?? '').replace(/[&<>"'`]/g, (c) => ESC[c]);

function render(v) {
  if (v === null || v === undefined || v === false) return '';
  if (v instanceof Raw) return v.s;
  if (Array.isArray(v)) return v.map(render).join('');
  return esc(v);
}

export function html(strings, ...vals) {
  let out = strings[0];
  for (let i = 0; i < vals.length; i++) out += render(vals[i]) + strings[i + 1];
  return new Raw(out);
}

// URL selamat untuk atribut src/href (menolak javascript:, data: selain imej)
export function safeUrl(u) {
  const s = String(u || '');
  if (/^(https?:)?\/\//i.test(s) || s.startsWith('/') || s.startsWith('#')) return s;
  if (/^data:image\/(png|jpe?g|webp|svg\+xml);/i.test(s)) return s;
  return '#';
}

export function $(sel, root = document) { return root.querySelector(sel); }
export function $$(sel, root = document) { return [...root.querySelectorAll(sel)]; }
export function mount(el, content) { el.innerHTML = render(content); return el; }
